<template>
  <div
    style="height: 400px"
    class="d-flex justify-content-between vp-width-700"
  >
    <vpMultiselect
      :options="options"
      v-model="lang"
      trackBy="value"
      label="label"
      title="Language"
      @input="onInput"
    />
    <div>
      <p>Text test</p>
      {{ $t("navbar.search.text") }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      lang: "",
      options: [
        { value: "ar", label: "Arabic" },
        { value: "en", label: "English" },
      ],
    };
  },
  beforeMount() {
    this.lang = this.options.find((lang) => lang.value == this.getLanguage) || {
      value: "en",
      label: "English",
    };
  },
  methods: {
    ...mapActions("i18N", ["setLanguageAction"]),
    onInput(lang) {
      this.setLanguageAction(lang.value);
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
  },
};
</script>
